// extracted by mini-css-extract-plugin
module.exports = {"station-navigation":"StationNavigation_station-navigation__2gi5c","divider":"StationNavigation_divider__4UCm0"};